module.exports = __webpack_public_path__ + "img/kaisen_don.dcab229e.jpg";